import { render, staticRenderFns } from "./headerbg.vue?vue&type=template&id=113079eb&scoped=true&"
import script from "./headerbg.vue?vue&type=script&lang=js&"
export * from "./headerbg.vue?vue&type=script&lang=js&"
import style0 from "./headerbg.vue?vue&type=style&index=0&id=113079eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113079eb",
  null
  
)

export default component.exports